import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const convertToDataTable = (data: IGetAtmType[]): IGetAtmType[] => {
  const dataTableData: IGetAtmType[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllAtmTypesList = async (): Promise<IGetAtmType[]> => {
  const response =  await axiosDefaultApi.get(`/api/AtmTypes/GetAtmTypes` );
  return convertToDataTable(response as unknown as IGetAtmType[]);
};

type QueryFnType = typeof getAllAtmTypesList;

type UseGetAllAtmTypesListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllAtmTypesList = ({ config }: UseGetAllAtmTypesListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllAtmTypesList'],
    queryFn: () => getAllAtmTypesList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};